const pre = '/bcos/monitor/';

export default {
    path: '/bcos/monitor',
    title: '系统监控',
    header: '',
    icon: 'md-desktop',
    children: [
        {
            path: `${pre}nodesMetric`,
            title: '节点监控',
        },
        {
            path: `${pre}hostMetric`,
            title: '主机监控',
        },
        {
            path: `${pre}emailAlarm`,
            title: '邮件告警配置',
        },
        {
            path: `${pre}emailAlarmType`,
            title: '告警类型配置',
        },
    ]
}
